<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "CC-wrapper"
};
</script>

<style>
</style>